/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Social_Media_TitleInputs */

const en_company_profile_social_media_title = /** @type {(inputs: Company_Profile_Social_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media`)
};

const de_company_profile_social_media_title = /** @type {(inputs: Company_Profile_Social_Media_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media`)
};

/**
* | output |
* | --- |
* | "Social Media" |
*
* @param {Company_Profile_Social_Media_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_social_media_title = /** @type {((inputs?: Company_Profile_Social_Media_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Social_Media_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_social_media_title(inputs)
	return en_company_profile_social_media_title(inputs)
});